import React from 'react'
import Temp from './component/wheather_temp/temp'



const App = () => {
  return (
    <>
      <Temp />
    </>
  )
}

export default App
